/**
 * Detección canónica de la "vista activa" del portal a partir de la URL.
 *
 * El portal vecino (`portal.calbucura.cl`) cambia de vista por ruta:
 * - `/tesoreria/*`  → Tesorería (shell `TesoreriaLayout`).
 * - `/admin/*` (y el alias histórico `/comision/*`) → Comisión.
 * - cualquier otro path → Vecino (dashboard, mis datos, etc.).
 *
 * Antes esta lógica estaba duplicada en 6 lugares (Header, BottomNav,
 * RolSelectorCombobox, UserMenu, version.ts y el gate de Suspensiones), cada
 * uno con su propio `startsWith`. Una sola definición evita que se
 * desincronicen al cambiar el esquema de rutas (Sprint 19a).
 *
 * Nota: `detectarModuloActivo` (lib/api/version.ts) reusa este helper pero
 * mapea `'vecino' → 'portal'` porque esa es la clave que espera el backend de
 * versiones; el contrato de esa función no cambia.
 */
export type VistaActiva = 'vecino' | 'comision' | 'tesoreria';

export function vistaActualPorPath(pathname: string): VistaActiva {
  if (pathname.startsWith('/tesoreria')) return 'tesoreria';
  if (pathname.startsWith('/admin') || pathname.startsWith('/comision')) {
    return 'comision';
  }
  return 'vecino';
}
